import { useMemo } from 'react';
import { sortBy } from '../../../shared/utils/sortUtils.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { EquipmentOption } from './types.ts';


export function useEquipmentOptions() {

    const { data: cncEquipments } = trpc.equipments.getAllCnc.useQuery(
        undefined,
        {
            refetchOnWindowFocus: false,
            refetchInterval: 10 * 60_000,
            select: (equipments) => sortBy([...equipments], it => it.displayName),
        }
    );

    const { data: customEquipments } = trpc.equipments.getAllCustom.useQuery(
        { isActive: true },
        {
            refetchInterval: 30 * 60_000,
            select: (equipments) => sortBy([...equipments], it => it.displayName),
        }
    );


    const equipments: EquipmentOption[] | null = useMemo(() => {
        if (!cncEquipments || !customEquipments) return null;
        else return [
            ...cncEquipments.map(it => ({
                id: it.id,
                displayName: it.displayName,
                type: 'cnc' as const
            })),
            ...customEquipments.map(it => ({
                id: it._id!,
                displayName: it.displayName,
                sharepointFolder: it.sharepointFolder,
                type: 'custom' as const
            })),
        ];
    }, [cncEquipments, customEquipments]);


    return { equipments };
}
